module.exports = __webpack_public_path__ + "assets/img/mobile.3c6662f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile.png
// module id = HXsc
// module chunks = 72